'use client';

import HomePageFeatureCarousel from '@/components/_rebrand/HomePageFeatureCarousel';
import {
  HOME_PAGE_CAROUSEL_PROPS,
} from '@/constants/use-cases-page-props';
import useStore from '@/stores/useStore';
import "@/styles/libs/swiper-overrides.css";
import { FC } from 'react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import IconTileBreakup from '../IconTileBreakup';

export interface HomeHeroModernProps {
  title: React.ReactNode;
  description: React.ReactNode;
  mobileImageExperience: {
    image: React.ReactNode;
    title: string;
  }[];
}

const HomeHeroModern: FC<HomeHeroModernProps> = ({
  title,
  description,
  mobileImageExperience = [],
}) => {
  const { setDemoModalOpen, setTrialModalOpen } = useStore();

  const onClickMenuButton = (action) => {
    switch (action) {
      case 'trial':
        setTrialModalOpen(true);
        break;
      case 'demo':
        setDemoModalOpen(true);
        break;

      default:
        break;
    }
  };

  const mobileSlider = (
    <div className="flex md:hidden w-full flex-wrap justify-center mt-[48px] relative">
      <Swiper
        pagination={{ type: "bullets", clickable: true }}
        slidesPerView={1.2}
        centeredSlides={true}
        spaceBetween={20}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, Pagination]}
      >
        {mobileImageExperience.map((mobile, index) =>
          <SwiperSlide key={`swiper-key-${index}`}>
            <div className="flex flex-wrap">
              <div className="flex w-full">
                {mobile.image}
              </div>
              <div className="flex w-full text-white justify-center font-500 text-h4 mt-[24px]">
                {mobile.title}
              </div>
            </div>
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  );

  return (
    <div className="bg-violet-900 text-white">
      <div className="-mt-header-height-mobile md:-mt-header-height-desktop pt-header-height-mobile md:pt-header-height-desktop">
        <div className="pt-6 md:pt-12 px-container-mobile md:px-container-desktop">
          <div className="mx-auto max-w-grid">
            <div className="flex flex-wrap justify-center w-full text-center">
              <h1 className="text-h1 md:text-display1">{title}</h1>
              <p className="text-center text-p2 mt-[32px]">{description}</p>
              <div className="flex justify-center w-full mt-[24px]">
                <ul className="flex">
                  <li className="mr-[16px]">
                    <button
                      className='block button button-size-medium button-primary-citron mr-[16px]'
                      onClick={() => {
                        onClickMenuButton("demo");
                      }}
                    >
                      Request a demo
                    </button>
                  </li>
                  <li>
                    <button
                      className="block button button-size-medium button-secondary-citron-300 ml-[16px]"
                      onClick={() => {
                        onClickMenuButton("trial");
                      }}
                    >
                      Start free trial
                    </button>
                  </li>
                </ul>
              </div>
              <div className="flex">
                <HomePageFeatureCarousel {...HOME_PAGE_CAROUSEL_PROPS} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex">
          {mobileSlider}
        </div>
      </div>
      <div className="hidden md:block h-30 md:h-[10vw] relative w-full overflow-hidden">
        <IconTileBreakup data-fill-color="#F5F5F5" className="absolute left-[-100vw] right-[-100vw] bottom-[-1px] w-[300vw] md:left-0 md:right-0 md:w-full h-auto text-gray-100" />
      </div>
      <div className="flex md:hidden relative w-full pt-[48px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="360" height="35" viewBox="0 0 360 35" fill="none" className="w-full">
          <path fillRule="evenodd" clipRule="evenodd" d="M-222 0.302527H-87.8333L-87.8337 11.605H46.333V0.302444L-87.8333 0.302527V-11H-222V0.302527ZM582 0.302527H447.833V-11H582V0.302527ZM447.833 0.302527L447.833 11.605H313.667V0.302444L447.833 0.302527ZM180.5 22.9079H313.667V11.6054H180.5H179.5H46.3331V22.9079H179.5H180.5ZM582 40.921H447.833V35.0002H314V23.0002H447.833V14.4307H582V40.921ZM-87.8333 40.921H-222V14.4307H-87.8333V23.0002H45.9999V35.0002H-87.8333V40.921Z" fill="#F5F5F5" />
        </svg>
      </div>
    </div>
  );
};

export default HomeHeroModern;
